export enum InsuranceCompanyType {
  TPA = 'TPA',
  BOTH = 'Both',
  INSURANCE = 'Insurance',
}
